import { Home, Ban, Gem } from "lucide-react";
import { T } from "@/i18n";

export const Neighborhoods = ({ neighborhoods = [], avoid = [], gems = [] }) => (
  <div data-testid="neighborhoods-recommendations" className="grid gap-6 lg:grid-cols-[3fr_2fr]">
    <div className="print-break rounded-3xl border border-emerald-100 bg-white p-8">
      <p className="flex items-center gap-2 text-xs font-semibold uppercase tracking-widest text-emerald-700"><Home className="h-4 w-4" /><T>Dove alloggiare</T></p>
      <div className="mt-6 space-y-5">
        {neighborhoods.map((n, i) => (
          <div key={i} data-testid={`neighborhood-${i}`} className="border-l-2 border-emerald-500 pl-5">
            <div className="flex flex-wrap items-center gap-2">
              <h4 className="font-display text-lg font-semibold text-gray-900">{n.name}</h4>
              <span className="rounded-full bg-emerald-50 px-2.5 py-0.5 text-xs font-medium text-emerald-800">{n.budget_fit}</span>
            </div>
            {n.vibe && <p className="text-xs text-gray-500">{n.vibe}</p>}
            <p className="mt-2 text-sm leading-relaxed text-gray-600">{n.why}</p>
          </div>
        ))}
      </div>
      {avoid.length > 0 && (
        <div className="mt-8 rounded-2xl bg-slate-50 p-5">
          <p className="flex items-center gap-2 text-xs font-semibold uppercase tracking-widest text-gray-500"><Ban className="h-4 w-4" /><T>Zone da evitare per il tuo budget</T></p>
          {avoid.map((a, i) => (
            <p key={i} data-testid={`avoid-area-${i}`} className="mt-3 text-sm text-gray-600"><strong className="text-gray-900">{a.name}:</strong> {a.reason}</p>
          ))}
        </div>
      )}
    </div>
    <div className="print-break rounded-3xl bg-emerald-700 p-8 text-white">
      <p className="flex items-center gap-2 text-xs font-semibold uppercase tracking-widest text-emerald-200"><Gem className="h-4 w-4" /><T>Gemme locali</T></p>
      <ul className="mt-6 space-y-5">
        {gems.map((g, i) => (
          <li key={i} data-testid={`local-gem-${i}`}>
            <p className="font-display font-semibold">{g.name}</p>
            <p className="mt-1 text-sm leading-relaxed text-emerald-50/80">{g.description}</p>
          </li>
        ))}
      </ul>
    </div>
  </div>
);
